import React from 'react';
import { Field, NumericInput, TextOutput } from '../../../../../Components/Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Components/Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Components/Layout';
import { WorksheetBalanceFieldSet } from '../../../../../Components/Worksheets/Core';
import { IWorksheetComponent } from '../../../../../Components/Worksheets/Core/types';
import { HydrometerPortionAgitationSection } from './HydrometerPortionAgitationSection';
import { HydrometerPortionContainsOversizeParticlesCheckbox } from './HydrometerPortionContainsOversizeParticlesCheckbox';

const PortionWetPreparationSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection heading="Material Mass">
        <NamePrefixModifier appendNamePrefix="Masses">
          <NamePrefixModifier appendNamePrefix="MassMeasurement">
            <WorksheetBalanceFieldSet label="Balance" name="Equipment.Balance" />
            <Field input={<NumericInput />} name="TareMass" />
            <Field input={<NumericInput />} name="TareAndWetMass" />
          </NamePrefixModifier>
          <Field input={<TextOutput />} name="WetMass" />
          <Field input={<TextOutput />} name="DryMass" />
        </NamePrefixModifier>
        <HydrometerPortionContainsOversizeParticlesCheckbox appendNamePrefix="Preparation" />
      </ListFieldSection>
      <HydrometerPortionAgitationSection />
    </>
  );
};
const PortionWetPreparationSection = withInjectedProps(PortionWetPreparationSectionBase);

export { PortionWetPreparationSection };
export default PortionWetPreparationSection;
